<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
         x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"
         :width="size ? size : 512" :height="size ? size : 512"
         :class="[color]">
        <g>
            <path d="M504.171,239.489l-234.667-192c-6.357-5.227-15.189-6.293-22.656-2.773c-7.424,3.541-12.181,11.051-12.181,19.285v146.987    L34.837,47.489c-6.379-5.227-15.189-6.293-22.656-2.773C4.757,48.257,0,55.767,0,64.001v384c0,8.235,4.757,15.744,12.181,19.285    c2.923,1.365,6.059,2.048,9.152,2.048c4.843,0,9.621-1.643,13.504-4.821l199.829-163.499v146.987    c0,8.235,4.757,15.744,12.181,19.285c2.923,1.365,6.059,2.048,9.152,2.048c4.843,0,9.621-1.643,13.504-4.821l234.667-192    c4.949-4.053,7.829-10.112,7.829-16.512S509.12,243.543,504.171,239.489z" fill="#000000" data-original="#000000" class=""></path>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconFastBackward",
    props: ['color', 'size'],
}
</script>

<style lang="scss" scoped>
svg{
    transform: rotateZ(180deg);
}

path{fill:white}

.dark{
    path{
        fill:#4a4a5a;
    }
}
</style>
